import React from "react";
import MoodleModules from "..";

const now = new Date();
now.setUTCHours(0, 0, 0, 0);

const variables = { zeitraum: { zeitraumVon: { gt: now.toISOString() } } };

const FutureModules: React.FC<{}> = () => {
  return (
    <div style={{ width: "100%" }}>
      <MoodleModules where={variables} hideImportButton />
    </div>
  );
};

export default FutureModules;
